'use client'

import { Smartphone } from 'lucide-react'
import { usePathname } from 'next/navigation'
import posthog from 'posthog-js'
import { useI18n } from '@/components/I18nProvider'

// Compact "Get app" pill that sits next to the user icon in the desktop headers.
// Hidden below md: the bar has no room there, and phones already reach the stores
// through the mobile menu / bottom nav and the /download page itself.
export function GetAppButton({ surface }: { surface: 'landing_nav' | 'app_header' }) {
  const pathname = usePathname()
  const context = useI18n()
  const t = context?.t || {}
  const seg = pathname?.split('/')[1]
  const locale = seg === 'es' ? 'es' : seg === 'ja' ? 'ja' : 'en'

  return (
    // Plain <a>, like the other /download links: the page sends phones to a store
    // with a top-level navigation, which client-side routing would get in the way of.
    <a
      href={`/${locale}/download`}
      onClick={() =>
        posthog.capture('get_app_clicked', { surface, platform: 'web' }, { send_instantly: true })
      }
      className="hidden md:inline-flex items-center gap-1.5 whitespace-nowrap rounded-full border border-white/15 bg-white/[0.03] px-3 py-1.5 text-sm font-medium text-white/80 transition-colors hover:bg-white/10 hover:text-white"
    >
      <Smartphone size={15} strokeWidth={2} />
      {t.download?.getApp || 'Get app'}
    </a>
  )
}
